<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：项目信息v-loading="loading"
  -->
  <div class="pb50">
    <div class="product-content">
      <!--商品信息-->
      <div class="common-form mt16">项目信息</div>
      <div class="table-wrap" v-if="detail.order_master">
        <el-table size="small" :data="detail.order_master.product" border style="width: 100%">
          <el-table-column prop="productName" label="项目名称"></el-table-column>
          <el-table-column prop="total_price" label="价格">
            <template slot-scope="scope">
              <div class="red">￥ {{ scope.row.total_price ? scope.row.total_price : 0.00 }} 元</div>
            </template>
          </el-table-column>
          <el-table-column prop="isClock" label="是否加钟" min-width="100">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="info">
                  <div v-if="scope.row.isClock == 1" class="price">是</div>
                  <div v-else class="name">否</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="serviceTime" label="服务时长（分钟)"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <!-- filePath -->
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
  props: ["detail"],
  data() {
    return {
      /*是否加载完成*/
      loading: true
      /*订单数据*/
      // detail: {
      //   product: []
      // }
    };
  },
  created(e) {
    /*获取列表*/
    // this.getParams();
  },
  methods: {
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.orderId;
      OrderApi.orderdetail(
        {
          orderId: params
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.detail = data.data.detail;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/refund/part/project.vue